import {OrderIntakeOptionsDto} from '@hconnect/tuc-processes/orderIntake'

import {api} from '../../../../App.global'
import {
  ORDER_REQUESTS_API_PATH,
  V2_ORDER_REQUESTS_API_PATH
} from '../../../../Organisms/OrderIntake/OrderIntake.action'

/**
 * Fetches RMC order intake options from the v2/OrderRequests API (or order-create when toggled)
 * @param customerId The customer ID from the selected job site
 * @param siteId The site ID from the selected job site
 * @param businessLine The business line (should be 'RMC')
 * @param salesOffice The sales office (optional)
 * @param marketArea The market area (optional)
 * @param apiPath The base API path to use (defaults to v2/OrderRequests)
 * @returns Promise with RMC order intake options
 */
export const fetchRmcOrderIntakeOptionsV2 = async (
  customerId: string,
  siteId: string,
  businessLine: string = 'RMC',
  salesOffice?: string,
  marketArea?: string,
  apiPath?: string
): Promise<OrderIntakeOptionsDto> => {
  if (!customerId) {
    throw new Error('Customer ID is required')
  }

  if (!siteId) {
    throw new Error('Site ID is required')
  }

  try {
    const basePath = apiPath ?? V2_ORDER_REQUESTS_API_PATH
    const response = await api.get<OrderIntakeOptionsDto>(`${basePath}/options`, {
      params: {
        customerId,
        siteId,
        businessLine,
        ...(salesOffice ? {salesOffice} : {}),
        ...(marketArea ? {marketArea} : {})
      }
    })

    return response.data
  } catch (error) {
    console.error('Error fetching RMC order intake options from v2 API:', error)
    throw error
  }
}
